module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-alert', {
    attrs: {
      "variant": _vm.alertVariant,
      "show": _vm.alertShow,
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.dismissMessage
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.alertInfo)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2532ac49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertHandler.vue
// module id = 696
// module chunks = 1